import { useState, useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { supabase } from '@/integrations/supabase/client';
import { MainLayout } from '@/components/layout/MainLayout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { UserManagementTab } from '@/components/team/UserManagementTab';
import { toast } from 'sonner';
import { Users, BookOpen, Megaphone } from 'lucide-react';

export default function TeamManagement() {
  const { membership } = useAuth();
  const [activeTab, setActiveTab] = useState('users');

  if (!membership) {
    return (
      <MainLayout>
        <div className="flex items-center justify-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
        </div>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div className="space-y-6">
        {/* Header */}
        <div>
          <h1 className="text-2xl font-bold">Team Management</h1>
          <p className="text-muted-foreground">
            Manage your organization's users, browse prompts, and communicate with your team.
          </p>
        </div>

        {/* Tabs */}
        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <TabsList>
            <TabsTrigger value="users" className="gap-2">
              <Users className="h-4 w-4" />
              Users
            </TabsTrigger>
            <TabsTrigger value="prompts" className="gap-2" disabled>
              <BookOpen className="h-4 w-4" />
              My Prompts
            </TabsTrigger>
            <TabsTrigger value="announcements" className="gap-2" disabled>
              <Megaphone className="h-4 w-4" />
              Announcements
            </TabsTrigger>
          </TabsList>

          <TabsContent value="users" className="mt-6">
            <UserManagementTab orgId={membership.org_id} />
          </TabsContent>

          <TabsContent value="prompts" className="mt-6">
            <div className="text-center py-12 text-muted-foreground">
              My Prompts coming soon...
            </div>
          </TabsContent>

          <TabsContent value="announcements" className="mt-6">
            <div className="text-center py-12 text-muted-foreground">
              Announcements coming soon...
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </MainLayout>
  );
}
